// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Buefy from 'buefy';
import Croppa from 'vue-croppa';
import VueAffix from 'vue-affix';
import VueNumeric from 'vue-numeric';
import VeeValidate from 'vee-validate';
import App from './App';
import router from './router';
import store from './store/index';
import './utils/filters';

Vue.use(Buefy);
Vue.use(Croppa);
Vue.use(VueAffix);
Vue.use(VueNumeric);
Vue.use(VeeValidate);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
  validations: {},
});



// WEBPACK FOOTER //
// ./src/main.js